import { Tabs } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";

const FOCUS_TAB = {
  "main-tab": "Risk Control",
  "tab-risk-detail": "Due Diligence",
};

export function initialFormTab(tabsKey, labels, { search = "", defaultValue = "" } = {}) {
  const params = new URLSearchParams(search);
  const names = labels || [];
  const requested = params.get("formTab");
  if (requested && names.includes(requested)) return requested;
  const focus = params.get("focus");
  const focused = focus === "nameScreening" ? FOCUS_TAB[tabsKey] : "";
  if (focused && names.includes(focused)) return focused;
  return defaultValue || names[0] || "";
}

const FormTab = ({
  getChildContainers,
  getChildFields,
  renderContainer,
  renderField,
  tabs,
  form,
  ...props
}) => {
  const { t: translate } = useTranslation();
  const visibleTabs = tabs?.tab.filter((tab) => {
    // console.log(tab, tab.showTab ? tab.showTab() : true);
    if (!tab.showTab) return true;
    if (!_.isFunction(tab.showTab)) return true;
    return tab.showTab(form.values, form.accessRight);
  });
  const [activeTab, setActiveTab] = useState(() =>
    initialFormTab(
      tabs?.key,
      (visibleTabs || []).map((tab) => tab.label),
      {
        search: typeof window === "undefined" ? "" : window.location.search,
        defaultValue: tabs?.props?.defaultValue || "",
      }
    )
  );

  const visibleLabels = (visibleTabs || []).map((tab) => tab.label).join("\0");

  useEffect(() => {
    const labels = visibleLabels ? visibleLabels.split("\0") : [];
    const handler = (event) => {
      if (event.detail?.tabsKey && event.detail.tabsKey !== tabs?.key) return;
      if (
        event.detail?.recordId &&
        String(event.detail.recordId) !== String(form?.values?._id || "")
      ) {
        return;
      }
      if (event.detail?.value && labels.includes(event.detail.value)) {
        setActiveTab(event.detail.value);
      }
    };
    window.addEventListener("mbid:open-form-tab", handler);
    return () => window.removeEventListener("mbid:open-form-tab", handler);
  }, [tabs?.key, form?.values?._id, visibleLabels]);

  return (
    <>
      <Tabs
        {...tabs.props}
        key={tabs.key}
        value={activeTab}
        onTabChange={setActiveTab}
      >
        <Tabs.List>
          {visibleTabs?.map(({ label, key, iconSize = 14, ...t }) => (
            <Tabs.Tab
              key={key}
              // icon={<t.icon size={iconSize}/>}
              value={label}
            >
              {translate(label)}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        {tabs.tab?.map(({ label, key }, index) => (
          <Tabs.Panel key={key} value={label} pt={"xl"}>
            {getChildContainers(key).map((c) => (
              <React.Fragment key={c.key}>{renderContainer(c)}</React.Fragment>
            ))}
            {getChildFields(key).map((f) => (
              <React.Fragment key={`${f.parent}-${f.name}`}>
                {renderField(f)}
              </React.Fragment>
            ))}
          </Tabs.Panel>
        ))}
      </Tabs>
    </>
  );
};

export default FormTab;
